module.exports = __webpack_public_path__ + "static/media/photo-2-1.e464a168.jpg";